import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Calendar, Users } from 'lucide-react';

const ContactHero = () => {
  return (
    <section className="relative py-32 bg-primary overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-15">
        <img 
          src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" 
          alt="" 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary/95 to-primary/80"></div>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="container mx-auto px-4 relative z-10"
      >
        <div className="max-w-4xl mx-auto">
          <div className="text-center text-white mb-12">
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="inline-block mb-4 bg-white/10 backdrop-blur-sm rounded-full px-6 py-2 text-sm font-semibold text-secondary">
                Siamo qui per te
              </div>
            </motion.div>
            
            <motion.h1 
              className="text-5xl md:text-6xl font-monomakh mb-6 leading-tight"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Contattaci
            </motion.h1>
            
            <motion.p 
              className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto leading-relaxed"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Siamo qui per rispondere a ogni tua domanda. Contattaci per una consulenza personalizzata 
              o per ricevere maggiori informazioni sui nostri servizi.
            </motion.p>
          </div>
          
          <motion.div 
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="max-w-4xl mx-auto bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20"
          >
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex flex-col items-center text-center p-4 rounded-lg bg-white/5 hover:bg-white/10 transition-colors">
                <div className="w-14 h-14 rounded-full bg-secondary/20 flex items-center justify-center mb-3">
                  <Phone className="h-6 w-6 text-secondary" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-1">Chiamaci</h3>
                <p className="text-gray-300 mb-2">+39 327 8855115</p>
                <p className="text-gray-300">055 752139</p>
              </div>
              
              <div className="flex flex-col items-center text-center p-4 rounded-lg bg-white/5 hover:bg-white/10 transition-colors">
                <div className="w-14 h-14 rounded-full bg-secondary/20 flex items-center justify-center mb-3">
                  <Mail className="h-6 w-6 text-secondary" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-1">Email</h3>
                <p className="text-gray-300">info@molinaroimmobiliare.it</p>
                <p className="text-gray-300">vendite@molinaroimmobiliare.it</p>
              </div>
              
              <div className="flex flex-col items-center text-center p-4 rounded-lg bg-white/5 hover:bg-white/10 transition-colors">
                <div className="w-14 h-14 rounded-full bg-secondary/20 flex items-center justify-center mb-3">
                  <MapPin className="h-6 w-6 text-secondary" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-1">Indirizzo</h3>
                <p className="text-gray-300">Via Pisana 327,</p>
                <p className="text-gray-300">50018 Scandicci (FI)</p>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>
      
      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-secondary opacity-5 rounded-tr-full"></div>
      <div className="absolute top-0 right-0 w-64 h-64 bg-secondary opacity-5 rounded-bl-full"></div>
    </section>
  );
};

export default ContactHero;